import styled from 'styled-components';
import { Modal, GlobalToken } from 'antd';

export const StyledModal = styled(Modal)<{ theme: { token: GlobalToken } }>`
  && {
    top: 8%;
    padding-bottom: 0;
  }

  .ant-modal-content {
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border-radius: ${({ theme: { token } }) => token.borderRadiusLG}px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    min-width: 356px; /* 95% of typical phone screen width (375px) */
    overflow: hidden;
  }

  .ant-modal-header {
    background: ${({ theme: { token } }) => token.colorBgContainer};
    border-bottom: none;
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingMD}px
      ${({ theme: { token } }) => token.paddingXS}px;

    .ant-modal-title {
      color: ${({ theme: { token } }) => token.colorTextHeading};
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    }
  }

  .ant-modal-body {
    padding: ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.paddingMD}px
      ${({ theme: { token } }) => token.paddingSM}px;
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    min-height: 0;

    .ant-form-item {
      margin-bottom: ${({ theme: { token } }) => token.marginXS}px;
    }

    .ant-form-item-label > label {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      height: auto;
    }

    .ant-input,
    .ant-input-number,
    .ant-select-selector {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      height: 36px;
    }

    .ant-input-number {
      height: 36px;
    }

    .ant-input-affix-wrapper {
      height: 36px;
      font-size: ${({ theme: { token } }) => token.fontSize}px;
    }

    textarea.ant-input {
      font-size: ${({ theme: { token } }) => token.fontSize}px;
      min-height: 90px;
    }
  }

  .ant-modal-footer {
    border-top: none;
    padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingMD}px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginSM}px;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    background: ${({ theme: { token } }) => token.colorBgContainer};
    z-index: 1;

    .footer-left {
      display: flex;
      align-items: center;
    }

    .footer-right {
      display: flex;
      align-items: center;
      gap: ${({ theme: { token } }) => token.marginSM}px;
    }
  }
`;
